import SvgIcon from "@material-ui/core/SvgIcon";

const RatherCoin = (props) => (
  <SvgIcon fontSize="large" viewBox="0 0 256 262" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid" {...props}>
    <svg
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      x={0}
      y={0}
      viewBox="0 0 944.9 931.86"
      style={{
        enableBackground: "new 0 0 944.9 931.86",
      }}
      xmlSpace="preserve"
      {...props}
    >
      <style>{".st0{fill:#dc9a2b}.st12{fill:#f8bb30}"}</style>
      <circle className="st0" cx={481.44} cy={465.93} r={449.42} />
      <linearGradient
        id="SVGID_1_"
        gradientUnits="userSpaceOnUse"
        x1={829.926}
        y1={907.692}
        x2={223.151}
        y2={190.136}
      >
        <stop
          offset={0}
          style={{
            stopColor: "#ffd861",
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: "#f9bc31",
          }}
        />
      </linearGradient>
      <circle
        cx={456.37}
        cy={465.93}
        r={442.32}
        style={{
          fill: "url(#SVGID_1_)",
        }}
      />
      <linearGradient
        id="SVGID_00000124879445927836724620000001761143325447179654_"
        gradientUnits="userSpaceOnUse"
        x1={170.044}
        y1={59.032}
        x2={582.953}
        y2={645.665}
      >
        <stop
          offset={0}
          style={{
            stopColor: "#fedf53",
          }}
        />
        <stop
          offset={0.513}
          style={{
            stopColor: "#fff195",
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: "#f9bc31",
          }}
        />
      </linearGradient>
      <circle
        style={{
          fill: "url(#SVGID_00000124879445927836724620000001761143325447179654_)",
        }}
        cx={456.44}
        cy={465.93}
        r={346.51}
      />
      <linearGradient
        id="SVGID_00000065042690869285585020000017629457247600946819_"
        gradientUnits="userSpaceOnUse"
        x1={206.992}
        y1={214.564}
        x2={708.343}
        y2={715.916}
      >
        <stop
          offset={0}
          style={{
            stopColor: "#fff",
          }}
        />
        <stop
          offset={0.252}
          style={{
            stopColor: "#dfd2b8",
          }}
        />
        <stop
          offset={0.516}
          style={{
            stopColor: "#c1a875",
          }}
        />
        <stop
          offset={0.738}
          style={{
            stopColor: "#ab8844",
          }}
        />
        <stop
          offset={0.905}
          style={{
            stopColor: "#9d7526",
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: "#986e1b",
          }}
        />
      </linearGradient>
      <path
        style={{
          fill: "url(#SVGID_00000065042690869285585020000017629457247600946819_)",
        }}
        d="M803.68 465.93c-.07 45.46-8.53 90.92-25.27 133.39-8.36 21.23-18.72 41.72-31.01 61.06-12.3 19.33-26.5 37.53-42.41 54.17-15.96 16.58-33.53 31.7-52.56 44.81l-7.22 4.78-3.62 2.38c-1.2.8-2.41 1.6-3.67 2.31l-7.46 4.41-3.73 2.21-1.87 1.1-1.92 1.01-7.69 4.02-3.85 2.01-1.93 1-1.97.91-7.88 3.64c-2.64 1.19-5.22 2.5-7.94 3.51a337.858 337.858 0 0 1-66.33 20.17c-22.72 4.44-45.89 6.52-69 6.29-23.11-.31-46.17-2.9-68.71-7.76a348.739 348.739 0 0 1-65.6-21.18c-42.15-18.34-80.4-44.93-112.54-77.4-32.12-32.51-58.01-71.08-75.84-113.19l-3.21-7.95c-1.04-2.66-2.21-5.27-3.09-8l-2.81-8.1c-.91-2.71-1.95-5.38-2.69-8.14l-2.44-8.23c-.78-2.75-1.71-5.46-2.33-8.26l-2.03-8.34-1.02-4.17-.5-2.09-.4-2.11c-4.69-22.42-7.34-45.3-7.69-68.27-.66-45.91 7.5-92.19 24.79-135.08 17.16-42.92 43.18-82.31 75.74-115.29a356.01 356.01 0 0 1 53.4-44.41c19.22-13 39.73-24.12 61.14-33.12 21.4-9.03 43.75-15.84 66.54-20.4 22.8-4.54 46.05-6.79 69.28-6.76 46.46.15 92.91 9.52 135.59 27.72 2.71 1.02 5.3 2.35 7.93 3.55l7.88 3.68 1.97.92 1.93 1.01 3.84 2.03 7.68 4.06 1.91 1.02 1.87 1.11 3.73 2.22 7.46 4.45c1.26.72 2.46 1.52 3.66 2.33l3.62 2.4 7.22 4.81c19 13.19 36.57 28.34 52.5 44.97 15.9 16.67 30.08 34.89 42.38 54.24 12.29 19.35 22.65 39.86 31 61.1 16.75 42.49 25.18 87.99 25.17 133.45zm-1.6 0-.48-16.96c-.37-5.64-.86-11.28-1.3-16.92-.09-1.41-.31-2.81-.49-4.21l-.56-4.2-1.13-8.4c-.1-.7-.18-1.4-.29-2.1l-.39-2.08-.77-4.17-1.57-8.33a327.092 327.092 0 0 0-20.54-64.41c-18.03-41.35-44.59-78.65-76.92-109.47-32.36-30.84-70.49-55.2-111.61-71.75-20.57-8.27-41.9-14.59-63.64-18.76-21.74-4.14-43.87-6.25-66.01-6.19-44.27.11-88.43 8.79-129.41 25.52-40.98 16.72-78.64 41.63-110.26 72.78-31.6 31.18-57.03 68.6-74.57 109.52l-3.16 7.73c-1.03 2.59-2.19 5.12-3.05 7.77l-2.78 7.88c-.9 2.64-1.93 5.23-2.66 7.92l-2.41 8c-.77 2.68-1.69 5.32-2.3 8.04l-2.01 8.12-1.01 4.06-.5 2.03-.4 2.05c-4.69 21.82-7.23 44.15-7.62 66.55-.68 44.78 7.43 89.9 24.47 131.58 16.88 41.72 42.44 79.97 74.47 111.62 32.03 31.67 70.58 56.54 112.27 72.9 41.7 16.39 86.43 24.28 130.93 23.74 44.51-.54 88.77-9.4 129.9-26.22 41.11-16.8 79.19-41.29 111.52-72.2 32.3-30.88 58.86-68.21 76.88-109.57 9.03-20.66 15.91-42.31 20.51-64.44l1.57-8.33.77-4.17.39-2.09c.11-.7.19-1.4.29-2.1l1.12-8.41.56-4.2c.18-1.4.4-2.8.49-4.21.44-5.64.92-11.28 1.28-16.92l.42-17z"
      />
      <linearGradient
        id="SVGID_00000017497768863231063530000015712669562245968047_"
        gradientUnits="userSpaceOnUse"
        x1={785.648}
        y1={309.092}
        x2={234.076}
        y2={613.806}
      >
        <stop
          offset={0}
          style={{
            stopColor: "#fedf53",
          }}
        />
        <stop
          offset={0.513}
          style={{
            stopColor: "#fff195",
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: "#f9bc31",
          }}
        />
      </linearGradient>
      <path
        style={{
          fill: "url(#SVGID_00000017497768863231063530000015712669562245968047_)",
        }}
        d="M488.95 483.61H279.26l-.16 66.5 264.84-2.26"
      />
      <linearGradient
        id="SVGID_00000042701225608998720860000003177159015655838390_"
        gradientUnits="userSpaceOnUse"
        x1={746.317}
        y1={237.898}
        x2={194.93}
        y2={542.51}
      >
        <stop
          offset={0}
          style={{
            stopColor: "#fedf53",
          }}
        />
        <stop
          offset={0.513}
          style={{
            stopColor: "#fff195",
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: "#f9bc31",
          }}
        />
      </linearGradient>
      <path
        style={{
          fill: "url(#SVGID_00000042701225608998720860000003177159015655838390_)",
        }}
        d="M514.51 287.65H279.27v66.5h231.07c37.3 0 77.34 13.07 77.34 65.37 0 50.52-29.59 64.08-84.42 64.08h-25.89v66.5h38.27c95.19 0 136.04-65.86 136.04-130.59 0-68.42-33.77-131.86-137.17-131.86z"
      />
      <linearGradient
        id="SVGID_00000004518449970146604200000015121003075304609177_"
        gradientUnits="userSpaceOnUse"
        x1={781.245}
        y1={301.123}
        x2={229.674}
        y2={605.837}
      >
        <stop
          offset={0}
          style={{
            stopColor: "#fedf53",
          }}
        />
        <stop
          offset={0.513}
          style={{
            stopColor: "#fff195",
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: "#f9bc31",
          }}
        />
      </linearGradient>
      <path
        style={{
          fill: "url(#SVGID_00000004518449970146604200000015121003075304609177_)",
        }}
        d="M279.27 287.65v100.56L550.86 660.2h106.77L279.27 287.65z"
      />
      <linearGradient
        id="SVGID_00000109727888037986932920000016177068787480127892_"
        gradientUnits="userSpaceOnUse"
        x1={802.167}
        y1={338.995}
        x2={250.596}
        y2={643.709}
      >
        <stop
          offset={0}
          style={{
            stopColor: "#fedf53",
          }}
        />
        <stop
          offset={0.513}
          style={{
            stopColor: "#fff195",
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: "#f9bc31",
          }}
        />
      </linearGradient>
      <path
        style={{
          fill: "url(#SVGID_00000109727888037986932920000016177068787480127892_)",
        }}
        d="M481.87 660.2h-95.03L279.1 550.11l.16-66.5h26.69L481.87 660.2z"
      />
      <linearGradient
        id="SVGID_00000067915230975073554290000007021678960803855294_"
        gradientUnits="userSpaceOnUse"
        x1={680.906}
        y1={119.496}
        x2={129.334}
        y2={424.21}
      >
        <stop
          offset={0}
          style={{
            stopColor: "#fedf53",
          }}
        />
        <stop
          offset={0.513}
          style={{
            stopColor: "#fff195",
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: "#f9bc31",
          }}
        />
      </linearGradient>
      <path
        style={{
          fill: "url(#SVGID_00000067915230975073554290000007021678960803855294_)",
        }}
        d="m279.27 287.65 67.54 66.5h6.59l-74.13-66.5z"
      />
      <linearGradient
        id="SVGID_00000012438751405326173970000011246484437171353277_"
        gradientUnits="userSpaceOnUse"
        x1={775.493}
        y1={290.71}
        x2={223.921}
        y2={595.424}
      >
        <stop
          offset={0}
          style={{
            stopColor: "#fedf53",
          }}
        />
        <stop
          offset={0.513}
          style={{
            stopColor: "#fff195",
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: "#f9bc31",
          }}
        />
      </linearGradient>
      <path
        style={{
          fill: "url(#SVGID_00000012438751405326173970000011246484437171353277_)",
        }}
        d="M374.46 483.61h103.72l-3.7-3.71-100.02 3.71z"
      />
      <linearGradient
        id="SVGID_00000089543931287235395530000011889691214261279362_"
        gradientUnits="userSpaceOnUse"
        x1={819.729}
        y1={370.784}
        x2={268.158}
        y2={675.498}
      >
        <stop
          offset={0}
          style={{
            stopColor: "#fedf53",
          }}
        />
        <stop
          offset={0.513}
          style={{
            stopColor: "#fff195",
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: "#f9bc31",
          }}
        />
      </linearGradient>
      <path
        style={{
          fill: "url(#SVGID_00000089543931287235395530000011889691214261279362_)",
        }}
        d="m439.58 548.82 104.36-.97 4.66 4.68-109.02-3.71z"
      />
      <linearGradient
        id="SVGID_00000018201646864747384150000015539449827624935854_"
        gradientUnits="userSpaceOnUse"
        x1={782.011}
        y1={302.509}
        x2={230.44}
        y2={607.223}
      >
        <stop
          offset={0}
          style={{
            stopColor: "#fedf53",
          }}
        />
        <stop
          offset={0.513}
          style={{
            stopColor: "#fff195",
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: "#f9bc31",
          }}
        />
      </linearGradient>
      <path
        style={{
          fill: "url(#SVGID_00000018201646864747384150000015539449827624935854_)",
        }}
        d="m279.1 550.12 92.3-.81 6.59 6.62-98.89-5.81z"
      />
      <path className="st0" d="M476.95 475.61H267.26l-.16 66.5 264.84-2.26" />
      <path
        className="st0"
        d="M502.51 279.65H267.27v66.5h231.07c37.3 0 77.34 13.07 77.34 65.37 0 50.52-29.59 64.08-84.42 64.08h-25.89v66.5h38.27c95.19 0 136.04-65.86 136.04-130.59 0-68.42-33.77-131.86-137.17-131.86z"
      />
      <path
        className="st0"
        d="M267.27 279.65v100.56L538.86 652.2h106.77L267.27 279.65zM469.87 652.2h-95.03L267.1 542.11l.16-66.5h26.69L469.87 652.2z"
      />
      <path
        className="st12"
        d="m267.27 279.65 67.54 66.5h6.59l-74.13-66.5zM362.46 475.61h103.72l-3.7-3.71-100.02 3.71zM427.58 540.82l104.36-.97 4.66 4.68-109.02-3.71zM267.1 542.12l92.3-.81 6.59 6.62-98.89-5.81z"
      />
    </svg>
  </SvgIcon>
);

export default RatherCoin;
